import React from 'react'
import { string } from 'prop-types'
import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const getTagColors = (promotionStatus) => {
  switch (promotionStatus) {
    case 'approved':
      return 'primary'
    case 'pending':
      return 'attention'
    default:
      return undefined
  }
}

const getTagText = (promotionStatus) => {
  switch (promotionStatus) {
    case 'pending':
      return 'Pending'
    case 'running':
      return 'Running'
    case 'approved':
      return 'Approved'
    case 'expired':
      return 'Expired'
    case 'declined':
      return 'Declined'
    case 'paused':
      return 'Paused'
    default:
      return 'No promotions'
  }
}

function PromotionStatusTag({ promotionStatus = null }) {
  return (
    <TagComponent color={getTagColors(promotionStatus)}>
      {getTagText(promotionStatus)}
    </TagComponent>
  )
}

PromotionStatusTag.propTypes = {
  promotionStatus: string,
}

export default PromotionStatusTag
